module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "idFrameApp",
    attrs: {
      "id": "idFrameApp"
    }
  }, [_c('div', {
    ref: "idFormLogin",
    attrs: {
      "id": "idFormLogin"
    }
  }, [_c('loginFrm', {
    key: _vm.KeyLogin,
    ref: "idLoginFrm"
  })], 1), _vm._v(" "), _c('div', {
    ref: "idMainL1",
    attrs: {
      "id": "idMainL1"
    }
  }, [_c('div', {
    ref: "idMainL2",
    attrs: {
      "id": "idMainL2"
    }
  }, [_c('div', {
    ref: "idFormTop",
    staticClass: "clrBG1",
    staticStyle: {
      "flex": "0 0 auto",
      "width": "100%",
      "border": "0px solid red"
    },
    attrs: {
      "id": "idFormTop"
    }
  }, [_c('topbar', {
    ref: "idTopbar",
    attrs: {
      "id": "idTopbar"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "idHSplit1",
    staticClass: "clrBG1",
    staticStyle: {
      "flex": "0 0 auto",
      "height": "5px",
      "border": "0px solid #00ffff"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1 0 auto",
      "width": "100%",
      "border": "0px solid black"
    }
  }, [_c('div', {
    ref: "idMainL3",
    attrs: {
      "id": "idMainL3"
    }
  }, [_c('div', {
    ref: "idRSplit1",
    staticClass: "clrBG1",
    staticStyle: {
      "flex": "0 0 auto",
      "height": "100%",
      "width": "5px",
      "border": "0px solid #00ffff"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idFormLeft",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid #00ff00"
    },
    attrs: {
      "id": "idFormLeft"
    }
  }, [_c('MainMenu', {
    ref: "idMainMenu",
    attrs: {
      "id": "idMainMenu"
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "idRSplit2",
    staticClass: "clrBG1",
    staticStyle: {
      "flex": "0 0 auto",
      "height": "100%",
      "width": "5px",
      "border": "0px solid #00ffff"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idMenuHidePan",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0px solid red",
      "width": "12px"
    }
  }, [_c('table', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_c('div', {
    ref: "idMenuHideArr",
    staticClass: "MenuHideArr1",
    staticStyle: {
      "float": "left",
      "margin-left": "-1px",
      "cursor": "pointer",
      "width": "11px",
      "height": "78px"
    },
    attrs: {
      "id": "idMenuHideArr"
    },
    on: {
      "click": _vm.onMenuHideClick
    }
  })])])])]), _vm._v(" "), _c('div', {
    ref: "idFormOP",
    staticStyle: {
      "flex": "1 0 auto",
      "z-index": "0",
      "border": "0px solid #ffff00"
    },
    attrs: {
      "id": "idFormOP"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "border": "0px solid #0000ff"
    }
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    ref: "idRSplit3",
    staticClass: "clrBG1",
    staticStyle: {
      "flex": "0 0 auto",
      "height": "100%",
      "width": "5px",
      "border": "0px solid #00ffff"
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "idHSplit2",
    staticClass: "clrBG1",
    staticStyle: {
      "flex": "0 0 auto",
      "height": "5px",
      "border": "0px solid #00ffff"
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "idDlgMask",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "idDlgMask"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idDlgFrm",
    staticStyle: {
      "position": "absolute",
      "z-index": "990",
      "width": "100%",
      "height": "100%",
      "border": "0px solid red",
      "display": "none"
    },
    attrs: {
      "id": "idDlgFrm"
    },
    on: {
      "click": _vm.onDlgClick
    }
  }, [_c('div', {
    ref: "idDlgRun",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "idDlgRun"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idDlgTip",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "idDlgTip"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idDlgCfm",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "idDlgCfm"
    }
  }, [_c('div', {
    ref: "idCfmCapt",
    staticClass: "DIVNoSelect",
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px",
      "background": "#2a83cf",
      "border-radius": "7px 7px 0px 0px",
      "text-indent": "10px",
      "color": "#ffffff"
    },
    attrs: {
      "id": "idCfmCapt"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "border": "0px solid blue",
      "margin-top": "6px"
    }
  }, [_c('div', {
    ref: "idCfmIcon",
    staticStyle: {
      "float": "left",
      "margin-left": "30px",
      "width": "32px",
      "height": "32px"
    },
    attrs: {
      "id": "idCfmIcon"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idCfmMsg",
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "width": "300px",
      "height": "64px",
      "line-height": "32px",
      "border": "0px solid red",
      "font-size": "18px",
      "letter-spacing": "1px",
      "text-overflow": "ellipsis",
      "overflow": "hidden"
    },
    attrs: {
      "id": "idCfmMsg"
    }
  }), _vm._v(" "), _c('div', {
    ref: "idCfmRemk",
    staticStyle: {
      "float": "left",
      "margin-left": "20px",
      "width": "360px",
      "height": "50px",
      "line-height": "16px",
      "border": "0px solid red",
      "font-size": "14px",
      "text-indent": "29px",
      "text-overflow": "ellipsis",
      "overflow": "hidden",
      "display": "-webkit-box",
      "-webkit-line-clamp": "3",
      "-webkit-box-orient": "vertical",
      "margin-top": "10px"
    },
    attrs: {
      "id": "idCfmRemk"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "float": "left",
      "border": "0px solid red",
      "margin-top": "16px"
    }
  }, [_c('div', {
    ref: "idCfmOK",
    staticClass: "NButton",
    staticStyle: {
      "width": "70px",
      "margin-top": "-1px",
      "margin-left": "100px"
    },
    attrs: {
      "id": "idCfmOK"
    },
    on: {
      "click": _vm.onCfmOKClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("确定")))]), _vm._v(" "), _c('div', {
    ref: "idCfmCan",
    staticClass: "NButton",
    staticStyle: {
      "width": "70px",
      "margin-top": "-1px",
      "margin-right": "100px",
      "float": "right"
    },
    attrs: {
      "id": "idCfmCan"
    },
    on: {
      "click": _vm.onCfmCanClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("取消")))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f926c0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/FrameApp.vue
// module id = 803
// module chunks = 1